// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"_3PYKiCo6xALeaXu3xczDRL","preview":"_-1ich2r0zCvexPe6UIgFr"};